// extracted by mini-css-extract-plugin
module.exports = {"heading":"RichText_heading__4OKF5"};